﻿import {createAsyncStore} from "./async.store";
import {getProjectExpanded} from "../api/projects.api";

export const projectStore = createAsyncStore(
    getProjectExpanded
);